import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Button, Container, Row } from "reactstrap";
import s from "./styles.scss";
import ImagePreview from "./imagePreview";
import jsPDF from "jspdf";
import { errorNotification } from "../../../../utils/notifications";

interface Props {
  minPhotos: number;
  exportButtonTitle: string;
  exportFile: (pdf: File) => any;
}

interface State {
  photos: any[];
}

class CamMultiCapture extends React.Component<Props, State> {
  state = {
    photos: []
  };

  componentDidMount() {
    this.startCamera();
  }

  startCamera = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      const video = document.getElementById("multiCaptureCameraVideo");

      (function(video) {
        navigator.mediaDevices
          .getUserMedia({ video: { facingMode: "environment" } })
          .then(stream => {
            video.srcObject = stream;
            video.play();
          });
      })(video);
    }
  };

  takePhoto = () => {
    let video = document.getElementById("multiCaptureCameraVideo");
    let canvas = document.getElementById("multiCaptureCameraCanvas");
    canvas.getContext("2d").drawImage(video, 0, 0, 640, 480);
    this.setState({
      photos: [...this.state.photos, canvas.toDataURL("image/jpeg", 1.0)]
    });
    canvas = null;
    video = null;
  };

  exportToPdf = () => {
    const { photos } = this.state;
    const minPhotos = this.props.minPhotos || 1;
    if (photos.length < minPhotos) {
      errorNotification(
        `Debe capturar al menos ${minPhotos} foto(s) del documento`
      );
      return;
    }

    const pdf = new jsPDF();

    const padding = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const availableHeight = pageHeight - 2 * padding;

    let totalOriginalHeight = 0;
    let scaledImages: { width: number; height: number; dataURL: string }[] = [];

    photos.forEach(dataURL => {
      const imgProps = pdf.getImageProperties(dataURL);
      const imgWidth = pageWidth - 2 * padding;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
      totalOriginalHeight += imgHeight;
      scaledImages.push({ width: imgWidth, height: imgHeight, dataURL });
    });

    if (photos.length === 1) {
      const img = scaledImages[0];
      const imgProps = pdf.getImageProperties(img.dataURL);

      const scaleX = (pageWidth - 2 * padding) / imgProps.width;
      const scaleY = (pageHeight - 2 * padding) / imgProps.height;
      const scale = Math.min(scaleX, scaleY);

      const scaledWidth = imgProps.width * scale;
      const scaledHeight = imgProps.height * scale;
      const xPosition = (pageWidth - scaledWidth) / 2;
      const yPosition = (pageHeight - scaledHeight) / 2;

      pdf.addImage(
        img.dataURL,
        "PNG",
        xPosition,
        yPosition,
        scaledWidth,
        scaledHeight
      );
    } else {
      const scaleFactor = availableHeight / totalOriginalHeight;
      let yPosition = padding;

      scaledImages.forEach(img => {
        const scaledWidth = img.width * scaleFactor;
        const scaledHeight = img.height * scaleFactor;
        pdf.addImage(
          img.dataURL,
          "PNG",
          padding,
          yPosition,
          scaledWidth,
          scaledHeight
        );
        yPosition += scaledHeight;
      });
    }

    const pdfBlob = pdf.output("blob");
    var file = new File([pdfBlob], "documento.pdf", {
      type: "application/pdf"
    });
    //var fileURL = URL.createObjectURL(file);
    //window.open(fileURL);
    if (!!this.props.exportFile) {
      this.props.exportFile(file);
    }
  };

  openToPdf = () => {
    const { photos } = this.state;
    const minPhotos = this.props.minPhotos || 1;
    if (photos.length < minPhotos) {
      errorNotification(
        `Debe capturar al menos ${minPhotos} foto(s) del documento`
      );
      return;
    }

    const pdf = new jsPDF();

    const padding = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const availableHeight = pageHeight - 2 * padding;

    let totalOriginalHeight = 0;
    let scaledImages: { width: number; height: number; dataURL: string }[] = [];

    photos.forEach(dataURL => {
      const imgProps = pdf.getImageProperties(dataURL);
      const imgWidth = pageWidth - 2 * padding;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
      totalOriginalHeight += imgHeight;
      scaledImages.push({ width: imgWidth, height: imgHeight, dataURL });
    });

    if (photos.length === 1) {
      const img = scaledImages[0];
      const imgProps = pdf.getImageProperties(img.dataURL);

      const scaleX = (pageWidth - 2 * padding) / imgProps.width;
      const scaleY = (pageHeight - 2 * padding) / imgProps.height;
      const scale = Math.min(scaleX, scaleY);

      const scaledWidth = imgProps.width * scale;
      const scaledHeight = imgProps.height * scale;
      const xPosition = (pageWidth - scaledWidth) / 2;
      const yPosition = (pageHeight - scaledHeight) / 2;

      pdf.addImage(
        img.dataURL,
        "PNG",
        xPosition,
        yPosition,
        scaledWidth,
        scaledHeight
      );
    } else {
      const scaleFactor = availableHeight / totalOriginalHeight;
      let yPosition = padding;

      scaledImages.forEach(img => {
        const scaledWidth = img.width * scaleFactor;
        const scaledHeight = img.height * scaleFactor;
        pdf.addImage(
          img.dataURL,
          "PNG",
          padding,
          yPosition,
          scaledWidth,
          scaledHeight
        );
        yPosition += scaledHeight;
      });
    }

    const pdfBlob = pdf.output("blob");
    var file = new File([pdfBlob], "documento.pdf", {
      type: "application/pdf"
    });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  render() {
    return (
      <Container className="mt-3 p-0 mb-5">
        <div className="m-4 text-center">
          <video
            id="multiCaptureCameraVideo"
            src=""
            width="500px"
            height="375px"
          />
        </div>
        <div>
          <canvas
            style={{ display: "none" }}
            id="multiCaptureCameraCanvas"
            width="640px"
            height="480px"
          />
        </div>
        <div className="m-4 text-center">
          <Button
            className="bg-secondary mr-4"
            size="md"
            onClick={e => {
              e.preventDefault();
              this.takePhoto();
            }}
          >
            Tomar foto
          </Button>

          <Button
            className="bg-info mr-4"
            size="md"
            onClick={e => {
              e.preventDefault();
              this.exportToPdf();
            }}
          >
            {this.props.exportButtonTitle || "Expotar"}
          </Button>

          {/* <Button
            className="bg-info mr-4"
            size="md"
            onClick={e => {
              e.preventDefault();
              this.openToPdf();
            }}
          >
            Ver pdf
          </Button> */}
        </div>

        <Row className="mt-4">
          {(this.state.photos || []).map((uri, index) => {
            return (
              <ImagePreview
                key={index}
                index={index}
                dataUri={uri}
                _delete={index => {
                  const arr = [...this.state.photos];
                  arr.splice(index, 1);
                  this.setState({ photos: [...arr] });
                }}
              />
            );
          })}
        </Row>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(CamMultiCapture));
